module.exports = __webpack_public_path__ + "static/media/enter 1.278bc0f3.svg";